import React from "react";
import { makeStyles } from "@material-ui/core/";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
// import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import VisibilitySensor from "react-visibility-sensor";

import mainServices from "../info/mainServices";
import services from "../info/services";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#f5dd3a",
    padding: "3rem 2rem",
    transition: "all .3s smooth",
  },
  mainServices: {
    marginTop: "2em",
    marginBottom: "2em",
  },
  mainServiceCard: {
    height: "10em",
    borderRadius: "1em",
    fontFamily: "Ariel",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "2em",
      marginBottom: "0",
    },
  },
  services: {
    display: "flex",
    justifyContent: "center",
    padding: "0 1em",
    [theme.breakpoints.up("sm")]: {
      padding: "0 2em",
    },
  },
  serviceCard: {
    height: "5em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "1em",
    color: "#1c4c99",
    background: "#ffc522",
    border: "3px solid #1c4c99",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "2em",
    },
  },
}));

const ServicesContainer = ({ refProp, setRefInView }) => {
  const classes = useStyles();
  return (
    <VisibilitySensor
      // minTopValue={100}
      partialVisibility
      onChange={(isVisible) => isVisible && setRefInView("services")}
    >
      {({ isVisible }) => (
        <div
          ref={refProp}
          className={classes.root}
          style={{
            opacity: `${isVisible ? "1" : "0.25"}`,
          }}
        >
          <Typography variant="h4" style={{ fontWeight: "600" }}>
            {"Services"}
          </Typography>
          <div>
            <Grid container spacing={3} className={classes.mainServices}>
              {mainServices.map((s, idx) => {
                if (idx===0)
                  return(
                    <Grid item key={idx} xs={12} sm={12} md={6} xl={6}>
                      <Card className={classes.mainServiceCard} variant="outlined" style={{color: "#43a047",
    background: "#fff", border: "3px solid #43a047"}}>
                        <CardContent>
                          <span style={{fontWeight:"900", fontSize:"1.8em"}}>{s.title}</span>
                          <div style={{marginTop:"1em"}}>{s.icon}</div>
                          </CardContent>
                      </Card>
                    </Grid>
                  );
                if(idx===1)
                return(
                  <Grid item key={idx} xs={12} sm={12} md={6} xl={6}>
                    <Card className={classes.mainServiceCard} variant="outlined" style={{color: "#e53935",
    background: "#fff", border: "3px solid #e53935"}}>
                      <CardContent>
                        <span style={{fontWeight:"900", fontSize:"1.8em"}}>{s.title}</span>
                        <div style={{marginTop:"1em"}}>{s.icon}</div>
                        </CardContent>
                    </Card>
                  </Grid>
                );
                return (
                  <Grid item key={idx} xs={12} sm={12} md={6} xl={6}>
                    <Card className={classes.mainServiceCard} variant="outlined" style={{color: "#ffc522",
    background: "#1565C0"}}>
                      <CardContent>
                        <span style={{fontWeight:"900", fontSize:"1.8em"}}>{s.title}</span>
                        <div style={{marginTop:"1em"}}>{s.icon}</div>
                        </CardContent>
                    </Card>
                  </Grid>
                  );
                })}
            </Grid>
            <Grid container spacing={3} className={classes.services}>
              {services.map((s, idx) => (
                <Grid item key={idx} xs={12} sm={4} md={3} xl={2}>
                  <Card className={classes.serviceCard} variant="outlined">
                    <CardContent>
                      <Typography style={{ fontWeight: "900" }}>{s}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </VisibilitySensor>
  );
};

export default ServicesContainer;
